const Seo = () => <div>SEO meta data</div>

export default Seo
